/**
 * @file コンポーネント：サイドメニュー ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// 関数読み込み
import {
    fnGetCultureLanguage,
    fnGetDepartmentCode,
    fnHandleApiErrors,
    fnHandleApiSuccess,
} from "~/src/functions/common";

// コンポーネントを返す
export const Sidemenu = (props) => {
    /**
     * 検索絞り込み状態
     */
    let keywordString = "";
    let operationNameString = "";
    let surgeonString = "";
    let tagString = "";
    let typeString = "";
    // 検索結果ページのみ
    if (window.dataSearch !== undefined) {
        keywordString = window.dataSearch.keywordString;
        operationNameString = window.dataSearch.operationNameString;
        surgeonString = window.dataSearch.surgeonString;
        tagString = window.dataSearch.tagString;
        typeString = window.dataSearch.typeString;
    }

    /**
     * UI表示言語でリンクが異なる場合アサインする
     */
    let linkAboutCompany; // 会社概要
    let linkHelp; // ヘルプ
    let linkPrivacypolicy; // プライバシーポリシー
    let linkSpecifiedCommercialTransactionAct; // 特定商取引法に基づく表記
    let linkTerms; // 利用規約
    switch (fnGetCultureLanguage()) {
        case "en":
            linkAboutCompany = "https://www.opexpark.co.jp/en/";
            linkHelp =
                "https://opexpark.notion.site/opeXpark-Help-English-0e682a6b9d9341298a8f3b787fb1f934";
            linkPrivacypolicy = "https://www.opexpark.co.jp/en/privacy/";
            linkSpecifiedCommercialTransactionAct =
                "https://www.opexpark.co.jp/specified-commercial/";
            linkTerms = "/termsofservice";
            break;
        case "ja":
            linkAboutCompany = "https://www.opexpark.co.jp";
            linkHelp =
                "https://opexpark.notion.site/opeXpark-39b40ac7f6364d89b59a3eab453225cc";
            linkPrivacypolicy = "https://www.opexpark.co.jp/privacy/";
            linkSpecifiedCommercialTransactionAct =
                "https://www.opexpark.co.jp/specified-commercial/";
            linkTerms = "/termsofservice";
            break;
        default:
            linkAboutCompany = "https://www.opexpark.co.jp/en/";
            linkHelp =
                "https://opexpark.notion.site/opeXpark-Help-English-0e682a6b9d9341298a8f3b787fb1f934";
            linkPrivacypolicy = "https://www.opexpark.co.jp/en/privacy/";
            linkSpecifiedCommercialTransactionAct =
                "https://www.opexpark.co.jp/specified-commercial/";
            linkTerms = "/termsofservice";
    }

    /**
     * カテゴリーリスト取得
     */
    const [categorylist, setCategorylist] = useState(null);
    useEffect(() => {
        const departmentCode =
            fnGetDepartmentCode() !== null ? fnGetDepartmentCode() : 1;
        const api = "/api/surgicals/" + departmentCode + "?language=" + fnGetCultureLanguage();
        fetch(api)
            .then(fnHandleApiErrors)
            .then(fnHandleApiSuccess)
            .then((result) => {
                if (result !== null) {
                    setCategorylist(result);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    /**
     * 執刀医リスト生成
     */
    const defaultDepartmentCode =
        fnGetDepartmentCode() !== null ? fnGetDepartmentCode() : 1; // 初期表示の診療科コード
    const [surgeonlist, setSurgeonlist] = useState(null);
    useEffect(() => {
        const api = "/api/surgeons/" + defaultDepartmentCode + "?language=" + fnGetCultureLanguage();
        fetch(api)
            .then(fnHandleApiErrors)
            .then(fnHandleApiSuccess)
            .then((result) => {
                if (result !== null) {
                    setSurgeonlist(result);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }, []);

    /**
     * 取得済みの診療科ごとのカテゴリーリスト
     */
    const [arrayCategorylist, setArrayCategorylist] = useState([]);
    useEffect(() => {
        if (categorylist !== null) {
            setArrayCategorylist([
                {
                    departmentCode: defaultDepartmentCode,
                    list: props.categorylist,
                },
            ]);
        }
    }, [categorylist]);

    /**
     * 取得済みの診療科ごとの執刀医リスト
     */
    const [arraySurgeonlist, setArraySurgeonlist] = useState([]);
    useEffect(() => {
        if (surgeonlist !== null) {
            setArraySurgeonlist([
                {
                    departmentCode: defaultDepartmentCode,
                    list: surgeonlist,
                },
            ]);
        }
    }, [surgeonlist]);

    /**
     * 検索する診療科コードに紐づく更新
     */
    const [isShowSearchFilter, setIsShowSearchFilter] = useState(false); // 検索フィルターの表示状態
    const [selectedCategorylist, setSelectedCategorylist] = useState(null); // 検索する診療科で選択中の診療科コードのカテゴリーリスト
    const [selectedDepartmentCode, setSelectedDepartmentCode] = useState(
        defaultDepartmentCode
    ); // 検索する診療科コード
    const [selectedSurgoenlist, setSelectedSurgeonlist] = useState([]); // 検索する診療科で選択中の診療科コードの執刀医リスト
    const [urlSearchAction, setUrlSearchAction] = useState(null); // 検索キーワードのform actionのURL
    useEffect(() => {
        if (props.departmentlist !== null) {
            // 検索フィルターの表示状態更新
            if (
                defaultDepartmentCode === selectedDepartmentCode &&
                (keywordString !== "" ||
                    surgeonString !== "" ||
                    tagString !== "" ||
                    typeString !== "")
            ) {
                setIsShowSearchFilter(true);
            } else {
                setIsShowSearchFilter(false);
            }
            // 検索キーワードのform actionのURL更新
            const department = props.departmentlist.filter(
                (d: { id: number }) => d.id === selectedDepartmentCode
            );
            if (department !== undefined) {
                setUrlSearchAction(department[0].link + "/search");
            }
            // 検索する診療科で選択中の診療科コードのカテゴリーリスト更新
            const filterCategorylist = arrayCategorylist.filter(
                (list: { departmentCode: number }) =>
                    list.departmentCode === selectedDepartmentCode
            );
            if (filterCategorylist.length > 0) {
                // 取得済みの場合、それを出力
                setSelectedCategorylist(filterCategorylist[0].list);
            } else {
                // 取得できていない場合、APIリクエストして取得してから出力
                const api = "/api/surgicals/" + selectedDepartmentCode + "?language=" + fnGetCultureLanguage();
                fetch(api)
                    .then(fnHandleApiErrors)
                    .then(fnHandleApiSuccess)
                    .then((result) => {
                        if (result !== null) {
                            const tempArrayCategorylist = arrayCategorylist;
                            tempArrayCategorylist.push({
                                departmentCode: selectedDepartmentCode,
                                list: result,
                            });
                            setArrayCategorylist(tempArrayCategorylist);
                            setSelectedCategorylist(result);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
            // 検索する診療科で選択中の診療科コードの執刀医リスト更新
            const filterSurgeonlist = arraySurgeonlist.filter(
                (list: { departmentCode: number }) =>
                    list.departmentCode === selectedDepartmentCode
            );
            if (filterSurgeonlist.length > 0) {
                // 取得済みの場合、それを出力
                setSelectedSurgeonlist(filterSurgeonlist[0].list);
            } else {
                // 取得できていない場合、APIリクエストして取得してから出力
                const api = "/api/surgeons/" + selectedDepartmentCode + "?language=" + fnGetCultureLanguage();
                fetch(api)
                    .then(fnHandleApiErrors)
                    .then(fnHandleApiSuccess)
                    .then((result) => {
                        if (result !== null) {
                            const tempArraySurgeonlist = arraySurgeonlist;
                            tempArraySurgeonlist.push({
                                departmentCode: selectedDepartmentCode,
                                list: result,
                            });
                            setArraySurgeonlist(tempArraySurgeonlist);
                            setSelectedSurgeonlist(result);
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            }
        }
    }, [props.departmentlist, arrayCategorylist, selectedDepartmentCode]);

    /**
     * 診療科プルダウン変更時の処理
     */
    const fnOnChangeSelectDepartment = (e) => {
        location.href = e.target.options[e.target.selectedIndex].value;
    };

    // Presenterに渡す
    return (
        <Presenter
            {...props}
            isShowSearchFilter={isShowSearchFilter}
            keywordString={keywordString}
            operationNameString={operationNameString}
            selectedCategorylist={selectedCategorylist}
            selectedDepartmentCode={selectedDepartmentCode}
            selectedSurgoenlist={selectedSurgoenlist}
            setSelectedDepartmentCode={setSelectedDepartmentCode}
            surgeonString={surgeonString}
            tagString={tagString}
            typeString={typeString}
            urlSearchAction={urlSearchAction}
            fnOnChangeSelectDepartment={fnOnChangeSelectDepartment}
            linkAboutCompany={linkAboutCompany}
            linkHelp={linkHelp}
            linkPrivacypolicy={linkPrivacypolicy}
            linkSpecifiedCommercialTransactionAct={
                linkSpecifiedCommercialTransactionAct
            }
            linkTerms={linkTerms}
        />
    );
};
